<script>
export default {
    props: [
        'accountInfo',
        'method'
    ],
    data() {
        return {
            lead: false,
            canxall: false
        };
    },
}
</script>
<template>
  <div>
    <div class="row-fluid text-center justify-content-center ">
      <p>Are all clients on this booking cancelling?</p>
      <div class="row justify-content-center ">
        <button
          class="btn btn-danger rounded" 
          @click="$emit('setAllBooking', false); $emit('nextStage', 4)"
        >
          No
        </button>
        <button
          class="btn btn-success rounded" 
          @click="$emit('setAllBooking', true); $emit('nextStage', 3)"
        >
          Yes
        </button>
      </div>
    </div>
    <div class="row-fluid">
      <button 
        v-if="canxall === 'Yes' && lead === 'Yes'"
        class="btn btn-info m-auto rounded" 
        @click="$emit('nextStage', 3)"
      >
        Proceed with Cancellation
      </button>
    </div>
  </div>
</template>